module.exports = __webpack_public_path__ + "static/img/7.7aa42c33.png";